const ɵ0 = () => 'sc';
export class InitialFormModule {
}
export { ɵ0 };
